import { useCallback, useState } from 'react';

interface UseExportHandlerProps {
  onExport: (fileName: string) => Promise<void> | void;
  getFileName: () => string;
}

export const useExportHandler = ({ onExport, getFileName }: UseExportHandlerProps) => {
  const [showExportModal, setShowExportModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  const handleExportClick = useCallback(() => {
    setShowExportModal(true);
  }, []);

  const handleExportConfirm = useCallback(async () => {
    try {
      setIsExporting(true);
      const fileName = getFileName();
      await onExport(fileName);
      setIsExporting(false);
      setShowExportModal(false);
    } catch (error) {
      console.error('Export failed:', error);
      setIsExporting(false);
      setShowExportModal(false);
      requestAnimationFrame(() => {
        setShowErrorModal(true);
      });
    }
  }, [getFileName, onExport]);

  const handleExportRetry = useCallback(() => {
    setShowErrorModal(false);
    setShowExportModal(true);
  }, []);

  return {
    showExportModal,
    showErrorModal,
    isExporting,
    setShowExportModal,
    setShowErrorModal,
    handleExportClick,
    handleExportConfirm,
    handleExportRetry,
  };
};
